import { PerspectiveCamera } from '@react-three/drei';
import useCollageTexture from './useCollageTexture';
import Billboard from './Billboard';
import Banner from './Banner';
import defaultImages from './images';
import { useMemo } from 'react';

const COUNT = 4;
const GAP = 2.6;

export function TowerEffect({ images = defaultImages, ...props }) {
    const { texture, dimensions, isLoading } = useCollageTexture(images);

    // Memoize the array of billboards and banners
    const towerElements = useMemo(() => {
        if (isLoading || !texture || !dimensions) return null;

        return Array.from({ length: COUNT }).map((_, index) => [
            <Billboard
                key={`billboard-${index}`}
                radius={5}
                rotation={[0, index * Math.PI * 0.5, 0]}
                position={[0, (index - (Math.ceil(COUNT / 2) - 1)) * GAP, 0]}
                texture={texture}
                dimensions={dimensions}
            />,
            <Banner
                key={`banner-${index}`}
                radius={5.035}
                rotation={[0, 0, 0.085]}
                position={[
                    0,
                    (index - (Math.ceil(COUNT / 2) - 1)) * GAP - GAP * 0.5,
                    0,
                ]}
            />,
        ]);
    }, [isLoading, texture, dimensions, images]);


    if (isLoading) {
        return  null
    }

    return (
        <group rotation={[-0.15, 0, -0.2]} {...props}>
            <PerspectiveCamera
                makeDefault
                fov={7}
                position={[0, -10, 70]}
                near={0.01}
                far={100000}
                zoom={1}
            >

            </PerspectiveCamera>
            {towerElements}
        </group>
    );
}
